<!-- header -->
<template>
  <div class="wrap clearfix">
    <div class="logo" v-show="InnerWidth">
      <div class="Titfl">英特尔合作伙伴集结号 报表系统</div>
      <div><img class="img" src="../../assets/intel-logo-highres.png"/></div>
      <div class="Titfr"><div v-if="!$route.meta.noLogn">{{`${username}（${$store.state.userData.memberOf}）`}}
        <span style="margin:0 20px">/</span>
        <span @click="edit">退出</span>
      </div></div>
    </div>
  </div>
</template>

<script>
import { formatUser } from '@/util/index'
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      InnerWidth:true,
    };
  },

  components: {},

  computed: {},

  mounted() {
    if (innerWidth <= 750) {
      this.InnerWidth = false;
      return;
    }
    this.$nextTick(function () {
      this.username=window.localStorage.getItem('displayname')
      formatUser()
    })
  },

  methods: {
    edit() {
      // this.$router.push({ path: "/login" });
      localStorage.clear()
     setTimeout(() => {
      window.location.href="https://consumer.intel.com/intelcorpb2c.onmicrosoft.com/B2C_1A_UNIFIEDLOGIN_SISU_STD_SAML/generic/login?entityId=https://partnersocial.intel.cn/report/v2" 
     }, 500);
    }
  }
};
</script>
<style lang='scss' scoped>
html,
body {
  width:100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
}
.logo {
  width: 100%;
  height: 60px;
  background-color: #0071c5;
  line-height: 58px;
  font-weight: 650;
  font-size: 21px;
  color: white;
  text-indent:1em;
  display: flex;
  justify-content: space-between;
    flex-wrap: nowrap;
    align-items:center ;

}
.logo .Titfl{
  display: inline;
  float: left;
  flex: 2;
}
.logo .Titfr{
  display: inline;
  text-align: right;
  font-size: 18px;
  font-weight: 400;
  padding-right: 80px;
  flex: 2;
}
.logo .Titfr span{
  cursor: pointer;
  /* text-decoration: underline; */
}
.img{
  height: 40px;
  padding: 9px 0;
  float: left;
}

</style>



// WEBPACK FOOTER //
// src/components/Layout/header.vue